import { Button } from '@/components/atoms/Button';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface ButtonsProps {
  zindex?: string;
}

export const Buttons = styled(Box)<ButtonsProps>(({ theme, zindex }) => ({
  display: 'flex',
  justifyContent: 'center',
  gap: theme.spacing(2.5),
  zIndex: zindex,
  [theme.breakpoints.down('md')]: {
    width: '100%',
    flexWrap: 'wrap',
  },
}));

interface ButtonProps {
  height?: number | string;
}

export const MunicipalityButton = styled(Button)<ButtonProps>(({ theme, height = '48px' }) => ({
  width: '100%',
  height,
  minWidth: '200px',
  maxWidth: '280px',
  color: theme.palette.text.primary,
  textTransform: 'none',
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
  },
}));

export const AdvancedButton = styled(Button)<ButtonProps>(({ theme, height = '48px' }) => ({
  width: '100%',
  height,
  minWidth: '200px',
  maxWidth: '280px',
  color: theme.palette.text.primary,
  borderColor: theme.palette.action.active,
  textTransform: 'none',
  '&:hover': {
    borderColor: theme.palette.action.hover,
    backgroundColor: theme.palette.action.hover,
  },
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
  },
}));
